export default __webpack_public_path__ + "assets/icons/header-country.16580020.svg";